import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { ValidaLoggedGuard } from './guard/valida-logged.guard';
import { LoginAyudaComponent } from './login-ayuda/login-ayuda.component';

const routes: Routes = [
  { path: 'micuenta', loadChildren: () => import('./micuenta/micuenta.module').then(m => m.MicuentaModule), data: { animationState: 'login' }, canActivate: [ValidaLoggedGuard] },
  { path: 'principal', loadChildren: () => import('./principal/principal.module').then(m => m.PrincipalModule) },
  { path: 'autos', loadChildren: () => import('./autos/autos.module').then(m => m.AutosModule) },
  { path: 'cotizacion', loadChildren: () => import('./cotizacion/cotizacion.module').then(m => m.CotizacionModule) },
  { path: 'datos-contratante', loadChildren: () => import('./datos-contratante/datos-contratante.module').then(m => m.DatosContratanteModule), canActivate: [ValidaLoggedGuard] },
  { path: 'funerarios', loadChildren: () => import('./funerario/funerarios.module').then(m => m.FunerarioModule) },
  { path: 'login', loadChildren: () => import('./login/login.module').then(m => m.LoginModule) },
  { path: 'menu', loadChildren: () => import('./menu/menu.module').then(m => m.MenuModule) },
  { path: 'datos-pago', loadChildren: () => import('./datos-pago/datos-pago.module').then(m => m.DatosPagoModule), canActivate: [ValidaLoggedGuard] },
  { path: 'landing/:productoID/:portalID', loadChildren: () => import('./landing/landing.module').then(m => m.LandingModule) },
  { path: 'auto-login-ayuda', component: LoginAyudaComponent },
  { path: 'vida', loadChildren: () => import('./vida/vida.module').then(m => m.VidaModule) },
  { path: 'casa', loadChildren: () => import('./casa/casa.module').then(m => m.CasaModule) },
  { path: 'mascotas', loadChildren: () => import('./mascotas/mascotas.module').then(m => m.MascotasModule) },
  { path: 'recibos', loadChildren: () => import('./recibos/recibos.module').then(m => m.RecibosModule), data: { animationState: 'detalle' } },
  { path: '', redirectTo: 'principal', pathMatch: 'full' },
  { path: '**', redirectTo: 'principal', pathMatch: 'full' }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, { scrollPositionRestoration: "top" } )],
  exports: [RouterModule]
})
export class AppRoutingModule { }
